import React from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Switch, message } from 'antd';
import { useUpdate } from '@refinedev/core';

interface LanguageDto {
  id: string;
  code: string;
  label: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const LanguageList: React.FC = () => {
  const { tableProps } = useTable<LanguageDto>({
    resource: 'languages',
    pagination: { current: 1, pageSize: 20 },
  });

  const { mutate: updateLanguage } = useUpdate();

  const handleToggle = (record: LanguageDto, checked: boolean) => {
    updateLanguage(
      {
        resource: 'languages',
        id: record.id,
        values: { isActive: checked },
      },
      {
        onSuccess: () => {
          message.success(`Language ${checked ? 'activated' : 'deactivated'}`);
        },
        onError: () => {
          message.error('Failed to update language');
        },
      },
    );
  };

  return (
    <List resource="languages">
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="code" title="Code" />
        <Table.Column dataIndex="label" title="Label" />
        <Table.Column
          dataIndex="isActive"
          title="Active"
          render={(isActive: boolean, record: LanguageDto) => (
            <Switch
              size="small"
              checked={isActive}
              onChange={(checked) => handleToggle(record, checked)}
            />
          )}
        />
        <Table.Column dataIndex="sortOrder" title="Sort Order" />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_: any, record: LanguageDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="languages" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="languages" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="languages" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
